const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleteIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    width: 32,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Complete_x5F_Symbol_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Complete_x5F_Symbol"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    id: "BG",
    r: 16,
    style: {
      fill: "#19D873"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Done_x5F_Symbol",
    points: "14,17.9 14,17.9 14,17.9 10.1,14 8,16.1         14,22.1 24,12.1 21.9,10 ",
    style: {
      fill: "#E6E6E6"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIconGreen);
export default __webpack_public_path__ + "static/media/CompleteIconGreen.7525d6410abcea0a5d5bced43885cb54.svg";
export { ForwardRef as ReactComponent };